import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=bd1aa1c2&"
import script from "./CreateGroup.vue?vue&type=script&lang=js&"
export * from "./CreateGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports